import React from "react";
import { Navigate } from "react-router-dom";


const SoProtectedRoute = ({ component: Component, ...rest }) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const is_Auth = userDetails?.token;
  const is_so_or_mdo = ["SO", "MDO", "RM", "AM"].includes(userDetails?.role);

  return is_Auth && is_so_or_mdo ? <Component {...rest} /> : <Navigate to="/login" />;
};

export default SoProtectedRoute;
